import React from "react";
import { useNavigate, Link } from "react-router-dom";
import PreviousAddressForm from "../Forms/PreviousAddressForm";
import { useDispatch } from "react-redux";
import { changeStep } from "../store/settings/settingsSlice";
import BackButton from "../Components/BackButton";
import { updateRegistrant } from "../store/registrant/registrantSlice";
import { getContent } from "../content";

function PreviousAddress() {
    let navigate = useNavigate();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(changeStep([4, 6]));
    }, []);

    const onSubmit = (data) => {
        Object.keys(data).forEach(key => data[key] === undefined ? delete data[key] : {});

        dispatch(updateRegistrant({
            ...data
        }));

        navigate('/new-address');
    };

    return (
        <section className="flex flex-col gap-4">
            <div className="">
                <BackButton onClick={() => navigate(-1)} />
                <h2 className="my-4 md:mt-8 lg:mt-16">{getContent('previous_address.heading')}</h2>
                <p className="my-4">{getContent('previous_address.content')}</p>
            </div>
            <div className="">
                <div className="border-4 border-evcpa-darkpurple rounded-lg p-8">
                    <PreviousAddressForm submit={onSubmit} />
                </div>
            </div>
        </section>
    );
}

export default PreviousAddress;